import { appVersion } from '@/lib/app-version';

export function AppFooter() {
  return (
    <footer className="mt-auto">
      <div className="mx-auto max-w-5xl px-4 pb-6 pt-2 sm:px-5">
        <p
          className="text-center text-[10px] font-medium tabular-nums tracking-[0.2em] text-[var(--color-muted)]/40 select-none"
          aria-label={`Application version ${appVersion}`}
        >
          v{appVersion}
        </p>
      </div>
    </footer>
  );
}
